<template>
  <nav class="navbar navbar-expand-lg navbar-transparent navbar-absolute trainer-navbar">
    <div class="container-fluid">
      <div class="navbar-wrapper">
        <button 
          class="btn trainer-sidebar-toggle"
          type="button"
          @click="toggleSidebar"
          :title="sidebarCollapsed ? 'Expandir menú lateral' : 'Ocultar menú lateral'"
          :class="{ 'collapsed': sidebarCollapsed }"
        >
          <i class="nc-icon" :class="sidebarCollapsed ? 'nc-menu-rows' : 'nc-simple-remove'"></i>
        </button>
        <a class="navbar-brand trainer-brand">Dashboard Personal Trainer</a>
      </div>
      <div class="navbar-custom">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item dropdown" :class="{ 'show': userMenuOpen }">
            <a 
              class="nav-link dropdown-toggle trainer-user-menu" 
              href="#" 
              @click.prevent="toggleUserMenu"
              role="button"
            >
              <i class="nc-icon nc-single-02"></i>
              <span class="d-lg-none d-md-block">Usuario</span>
            </a>
            <div class="dropdown-menu dropdown-menu-right" :class="{ 'show': userMenuOpen }">
              <div class="dropdown-header">
                <strong>Carlos Rodríguez</strong>
                <br><small class="text-muted">Personal Trainer</small>
              </div>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item" @click="goToProfile">
                <i class="nc-icon nc-single-02"></i> Mi Perfil
              </a>
              <a class="dropdown-item" @click="goToSettings">
                <i class="nc-icon nc-settings"></i> Configuración
              </a>
              <div class="dropdown-divider"></div>
              <a class="dropdown-item text-danger" @click="handleLogout">
                <i class="nc-icon nc-button-power"></i> Cerrar Sesión
              </a>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'TrainerHeader',
  props: {
    sidebarCollapsed: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      userMenuOpen: false
    }
  },
  mounted() {
    // Event listener para cerrar menú cuando se hace clic fuera
    document.addEventListener('click', this.handleClickOutside);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
  methods: {
    toggleSidebar() {
      this.$emit('toggle-sidebar');
    },
    toggleUserMenu() {
      this.userMenuOpen = !this.userMenuOpen;
    },
    handleClickOutside(event) {
      // Cerrar menú si se hace clic fuera del dropdown
      const dropdown = event.target.closest('.dropdown');
      if (!dropdown || !dropdown.querySelector('.trainer-user-menu')) {
        this.userMenuOpen = false;
      }
    },
    goToProfile() {
      this.userMenuOpen = false;
      this.$router.push({ name: 'TrainerProfile' });
    },
    goToSettings() {
      this.userMenuOpen = false;
      this.$router.push({ name: 'TrainerSettings' });
    },
    handleLogout() {
      this.userMenuOpen = false;
      this.$emit('logout');
    }
  }
}
</script>

<style lang="scss" scoped>
.trainer-navbar {
  --trainer-primary: #9ACD32;    /* Verde lima principal */
  --trainer-secondary: #7CB342;  /* Verde más oscuro */
  --trainer-accent: #8BC34A;     /* Verde intermedio */
  --trainer-dark: #689F38;       /* Verde oscuro */
  --trainer-light: #DCEDC8;      /* Verde muy claro */
  --trainer-bg: #F1F8E9;         /* Fondo muy suave */
  
  background: linear-gradient(0deg, rgba(255,255,255,0.96), rgba(255,255,255,0.94)) !important;
  box-shadow: 0 4px 18px 0px rgba(0,0,0,0.12), 0 7px 10px -5px rgba(0,0,0,0.15);
  border: none;

  .trainer-sidebar-toggle {
    background: transparent;
    border: 1px solid rgba(154, 205, 50, 0.3);
    color: var(--trainer-secondary);
    font-size: 14px;
    margin-right: 15px;
    padding: 6px 8px;
    border-radius: 6px;
    transition: all 0.2s ease;
    min-width: 32px;
    min-height: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    
    &:hover {
      background: rgba(154, 205, 50, 0.1);
      color: var(--trainer-primary);
      border-color: var(--trainer-primary);
      transform: none;
    }
    
    &:active {
      background: rgba(154, 205, 50, 0.2);
      transform: scale(0.95);
    }
    
    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(154, 205, 50, 0.2);
    }
    
    i {
      font-size: 14px;
      transition: transform 0.2s ease;
      
      &.nc-simple-remove {
        transform: rotate(45deg);
      }
    }
    
    &:hover i {
      transform: none;
      
      &.nc-simple-remove {
        transform: rotate(45deg);
      }
    }
    
    &.collapsed {
      background: rgba(154, 205, 50, 0.1);
      color: var(--trainer-primary);
      border-color: var(--trainer-primary);
      
      &:hover {
        background: rgba(154, 205, 50, 0.2);
        color: var(--trainer-dark);
      }
    }
  }

  .trainer-brand {
    color: var(--trainer-dark) !important;
    font-weight: 500;
    font-size: 18px;
  }

  .trainer-user-menu {
    color: var(--trainer-secondary) !important;
    transition: all 0.3s ease;
    padding: 8px 12px !important;
    border-radius: 6px;
    
    &:hover {
      color: var(--trainer-primary) !important;
      background: var(--trainer-light);
      transform: translateY(-1px);
    }
  }
  
  .dropdown.show .trainer-user-menu {
    color: var(--trainer-primary) !important;
    background: var(--trainer-light);
  }
  
  .dropdown-menu {
    border: none;
    box-shadow: 0 8px 25px rgba(0,0,0,0.15);
    border-radius: 8px;
    padding: 8px 0;
    margin-top: 8px;
    display: none;
    
    &.show {
      display: block;
    }
    
    .dropdown-header {
      padding: 12px 16px 8px 16px;
      color: var(--trainer-dark);
      
      strong {
        font-size: 14px;
      }
    }
    
    .dropdown-item {
      padding: 8px 16px;
      color: #333;
      transition: all 0.3s ease;
      cursor: pointer;
      
      &:hover {
        background: var(--trainer-light);
        color: var(--trainer-dark);
        transform: translateX(3px);
      }
      
      &.text-danger {
        color: #dc3545 !important;
        
        &:hover {
          background: rgba(220, 53, 69, 0.1);
          color: #dc3545 !important;
        }
      }
      
      i {
        margin-right: 8px;
        width: 16px;
        text-align: center;
      }
    }
    
    .dropdown-divider {
      margin: 8px 0;
      border-color: rgba(0,0,0,0.1);
    }
  }
}
</style>